import { ITeam } from 'core/api/rest/queries/select-teams'

export const getTeam = (teams: ITeam[] | null, teamId: number): ITeam | null =>
  teams?.find(team => team.id === teamId) ?? null
